import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Login/Login';
import Register from './Components/Register/Register';
// import Dashboard from './Components/Dashboard/Dashboard';
import PermissionManager from './Components/PermissionManager/PermissionManager';
import Dashboard from './Components/UserDashboard/Dashboard';




function App() {
  return (
    <Router>
      <Routes>
        {/* Default route redirects to Login */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/admin" element={<PermissionManager />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        {/* Dashboard Placeholder */}
        <Route path="/dashboard" element={
         <Dashboard/>
        } />

   
      </Routes>
    </Router>
  );
}

export default App;